import * as THREE from "three";
import edlFrag from "./shaders/edl.frag";

export class EDLMaterial extends THREE.ShaderMaterial {
    constructor(
        colorTexture: THREE.Texture,
        pointDepthTexture: THREE.DepthTexture,
        terrainColorTexture: THREE.Texture,
        terrainDepthTexture: THREE.DepthTexture,
        camNear: number,
        camFar: number,
    ) {
        super({
            glslVersion: "300 es",
            transparent: true,
            depthTest: false,
            depthWrite: false,
            uniforms: {
                uColorTexture: { value: colorTexture },
                uPointDepthTexture: { value: pointDepthTexture },
                uTerrainColorTexture: { value: terrainColorTexture },
                uTerrainDepthTexture: { value: terrainDepthTexture },
                uTerrainFade: { value: 1.0 },
                uOccludedOpacity: { value: 0.75 },
                uCameraNear: { value: camNear },
                uCameraFar: { value: camFar },
                uIsOrtho: { value: false },
                uFrustumWidth: { value: 0.0 },
                uResolution: { value: [100, 100] },
            },
            vertexShader: `
				out vec2 vUv;

				void main() {
					vUv = uv;

					mat4 modelToScreen = projectionMatrix * modelViewMatrix;

					gl_Position = modelToScreen * vec4(position, 1.0);
				}`,
            fragmentShader: edlFrag,
        });

        this.name = "EDLMaterial";
    }

    setResolution(width: number, height: number) {
        this.uniforms.uResolution.value = [width, height];
    }

    setTerrainFade(fade: number) {
        this.uniforms.uTerrainFade.value = fade;
    }

    updateCameraParams(camera: THREE.Camera) {
        if (camera instanceof THREE.OrthographicCamera) {
            this.uniforms.uIsOrtho.value = true;
            this.uniforms.uFrustumWidth.value = camera.right - camera.left;
            this.uniforms.uCameraNear.value = camera.near;
            this.uniforms.uCameraFar.value = camera.far;
        } else if (camera instanceof THREE.PerspectiveCamera) {
            this.uniforms.uIsOrtho.value = false;
            this.uniforms.uFrustumWidth.value = 0.0;
            this.uniforms.uCameraNear.value = camera.near;
            this.uniforms.uCameraFar.value = camera.far;
        }
    }
}
